<axs-modal #modal [axsSize]="'medium'" *ngIf="isOpen">
  <dialog #dialog class="modal_container">
    <axs-modal-close>
      <ngx-axs-button
        [axsText]="commonContent?.close"
        axsType="supplementary"
        axsTheme="black"
        axsIconType="close"
        (axsClick)="closeModal()"
      />
    </axs-modal-close>
    <axs-modal-content aria-label="Research Summary Modal Content">
      <div class="research-summary-modal__content" [class.visible]="contentVisible">
      <div class="research-summary-modal__header">
        <div class="research-summary-modal__label">
          {{ betrSummaryContent?.researchSummary }}
        </div>
        <h2 class="research-summary-modal__title">
          {{ betrSummaryContent?.betrTitle }}
        </h2>
      </div>

      <div class="research-summary-modal__intro text-body-2">
        <p>{{ betrSummaryContent?.betrIntro1 }}</p>
        <p>{{ betrSummaryContent?.betrIntro2 }}</p>
      </div>

      <div class="research-summary-modal__section">
        <h3 class="research-summary-modal__section-title">{{ betrSummaryContent?.coreFindings }}</h3>
        <div class="research-summary-modal__list" [innerHTML]="betrSummaryContent?.coreFindingsIntro"></div>
      </div>

      <div class="research-summary-modal__section">
        <h3 class="research-summary-modal__section-title">{{ betrSummaryContent?.implicationsForAdvisors }}</h3>
        <p>{{ betrSummaryContent?.implicationIntro1 }}</p>
        <p>{{ betrSummaryContent?.implicationIntro2 }}</p>
      </div>

      <div class="research-summary-modal__section">
        <h3 class="research-summary-modal__section-title">{{ betrSummaryContent?.advisorsShould }}</h3>
        <div class="research-summary-modal__list" [innerHTML]="betrSummaryContent?.advisorsIntro"></div>
      </div>

      <div class="research-summary-modal__section">
        <h3 class="research-summary-modal__section-title">{{ betrSummaryContent?.conclusion }}</h3>
        <p>{{ betrSummaryContent?.conclusion1 }}</p>
        <p>{{ betrSummaryContent?.conclusion2 }}</p>
        <p>{{ betrSummaryContent?.conclusion3 }}</p>
      </div>

        <div class="research-summary-modal__footer">
          <ngx-axs-button
            axsType="primary"
            axsTheme="black"
            axsSize="medium"
            [axsShowIcon]="true"
            axsIconType="download"
            [axsText]="needHelpContent?.research_link"
            [axsLink]="'https://advisors.vanguard.com/content/dam/fas/pdfs/ISGBETR.pdf'"
            [axsOpenInNewTab]="true"
            (axsClick)="onDownloadResearchPaper()"
          ></ngx-axs-button>
        </div>
      </div>
    </axs-modal-content>
  </dialog>
</axs-modal>
